import { render, staticRenderFns } from "./patientRegForm.vue?vue&type=template&id=525d49fd&scoped=true"
import script from "./patientRegForm.vue?vue&type=script&lang=js"
export * from "./patientRegForm.vue?vue&type=script&lang=js"
import style0 from "./patientRegForm.vue?vue&type=style&index=0&id=525d49fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525d49fd",
  null
  
)

export default component.exports